const Theme = {
  body_background_color: '#000000',

  card_background_color: '#000000',

  logo_image_url: 'secondevie.png',
  logo_height: 70,

  legend_color: '#DCDDDE',

  text_font: `'Nanum Gothic', sans-serif`,
  text_color: '#FFFFFF',

  button_color: '#F2E8D7',
  button_font: `'Nanum Gothic', sans-serif`,
  button_text_color: '#000000',

  button_half_border_color: '#F2E8D7',

  title_font: `'Merriweather', 'serif'`,
  title_color: '#F2E8D7',
  title_size: 28,
  title_weight: 700,

  subtitle_font: `'Nanum Gothic', sans-serif`,
  subtitle_color: '#FFFFFF',
  subtitle_weight: 400,

  separator_color: '#F2E8D7',

  footer_text_color: '#FFFFFF',
}

export default Theme
